<template lang="pug">
  div
    h2 About Us
    p We are a 501 (c)(3) non-profit organization that enhances the lives of people with disabilities by providing highly trained assistance dogs and ongoing follow-up services.
    p Hawaii CAN is a provisional member of Assistance Dog International, the organization that sets standards for the assistance dog industry.
    p
      strong Our Two-fold Mission
      br
      | #1 – To train and place high quality assistance dogs that are appropriately matched with individuals with mobility and hearing limitations living in Hawaii.
      br
      | #2 – To create partnerships with organizations that provide rehabilitative assistance to at-risk populations. These at-risk clients have the opportunity to care for and train Hawaii CAN pups under the supervision of trained personnel.
    p
      strong Current Board Members
      ul
        li Janel Yoshimoto
        li Laura Sue
        li Tiffany Kawaguchi
        li David Rair
        li Elizabeth Char

    p
      strong Contact
      address
        | 737 Bishop Street, Suite 2800
        br
        | Honolulu, Hawaii 96813
</template>

<script>

export default {
  name: 'AboutUs'
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/AboutUs.vue